import React from 'react'

export const StepsContext = React.createContext<{ orientation: string }>({
  orientation: 'horizontal',
})
